export const initialState = {
	data: [],
	boolMap: {},
	isLoading: false,
	isLoaded: false,
	errorMessage: undefined
};

export default initialState;
